import { TApplicationState } from '../../types/redux';

export function getSpecialPromo(state: TApplicationState) {
  const {
    newbuilding: { specialPromo },
  } = state;

  if (specialPromo) {
    return specialPromo;
  }

  return null;
}
